import React, { useState, useEffect } from "react";
import { Container, Col, Row, Card, CardBody, Table, Button } from "reactstrap";
import axios from "axios";
import { Link } from "react-router-dom";
// Import rank images
import firstPlaceImg from "../../assets/images/items/1st.png";
import secondPlaceImg from "../../assets/images/items/2nd.png";
import thirdPlaceImg from "../../assets/images/items/3rd.png";

// Import item images (for the top-three description)
import luckyEggImg from "../../assets/images/items/luckyegg.png";
import coinImg from "../../assets/images/items/coin.png";
import api from "../../api";
// Helper function to compute level from experience
function getLevel(exp) {
  const lvl = Math.floor(Math.pow(exp, 1 / 3));
  // If (lvl+1)^3 <= exp, increment level
  return Math.pow(lvl + 1, 3) <= exp ? lvl + 1 : lvl;
}

// Helper function to format a number with commas
function formatNumber(num) {
  return num.toLocaleString();
}

const TrainerRankings = () => {
  // Page state
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);

  // Data state for current page rankings
  const [trainers, setTrainers] = useState([]);

  // Data state for top three players (for description)
  const [topThree, setTopThree] = useState([]);

  // Loading and error state
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  document.title = "Trainer Rankings";

  // Fetch leaderboard data for the current page
  useEffect(() => {
    const fetchLeaderboard = async () => {
      setIsLoading(true);
      setError("");
      try {
        const response = await api.get(
          `/v1/trainer-rankings?page=${page}&limit=${limit}`,
          { withCredentials: true },
        );
        // Adjust based on your backend response structure
        const data = response.data.data;
        const totalCount = response.data.total || 0;
        setTrainers(data);
        setTotal(totalCount);
      } catch (err) {
        console.error(err);
        setError("Failed to load leaderboard");
      } finally {
        setIsLoading(false);
      }
    };

    fetchLeaderboard();
  }, [page, limit]);

  // Fetch top three players for the top description
  useEffect(() => {
    const fetchTopThree = async () => {
      try {
        const response = await api.get("/v1/trainer-rankings?page=1&limit=3", {
          withCredentials: true,
        });
        const data = response.data.data;
        setTopThree(data);
      } catch (err) {
        console.error("Failed to fetch top three players", err);
      }
    };
    fetchTopThree();
  }, []);

  // Calculate total pages
  const totalPages = Math.ceil(total / limit);

  const handlePrev = () => {
    if (page > 1) {
      setPage((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (page < totalPages) {
      setPage((prev) => prev + 1);
    }
  };

  // Build the top description with item images
  const topThreeDescription =
    topThree.length === 3 ? (
      <div style={{ lineHeight: "1.6", color: "white" }}>
        <p>
          Congratulations to the top 3 players:{" "}
          <strong>{topThree.map((p) => p.username).join(", ")}</strong>.
        </p>
        <p>
          1st place earns: Lucky Egg (60 mins){" "}
          <img
            src={luckyEggImg}
            alt="Lucky Egg"
            style={{
              width: "24px",
              verticalAlign: "middle",
              marginLeft: "5px",
              marginRight: "5px",
            }}
          />
          <br />
          2nd place earns: Lucky Egg (30 mins){" "}
          <img
            src={luckyEggImg}
            alt="Lucky Egg"
            style={{
              width: "24px",
              verticalAlign: "middle",
              marginLeft: "5px",
              marginRight: "5px",
            }}
          />
          <br />
          3rd place earns:
          <img
            src={coinImg}
            alt="Coins"
            style={{
              width: "24px",
              verticalAlign: "middle",
              marginLeft: "5px",
            }}
          />
          250
        </p>
        <p>
          <em>All rewards will be distributed at the end of the day. These rewards won't be given until battling is implemented.</em>{" "}
          (Banned or frozen accounts are not included.)
        </p>
      </div>
    ) : (
      "Loading top players..."
    );

  // Helper: Get rank image based on rank number (for top 3 rows)
  const getRankImage = (rank) => {
    if (rank === 1) return firstPlaceImg;
    if (rank === 2) return secondPlaceImg;
    if (rank === 3) return thirdPlaceImg;
    return null;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <h4 className="mb-4">Trainer Rankings</h4>

                  {/* Top description container 
                  <div
                    style={{
                      marginBottom: "20px",
                      padding: "15px",
                      backgroundColor: "#2a2f38",
                      borderRadius: "8px",
                      textAlign: "center",
                      fontSize: "1rem",
                      color: "#333",
                    }}
                  >
                    {topThreeDescription}
                  </div>
*/}
                  {isLoading && <div>Loading leaderboard...</div>}
                  {error && <div className="text-danger">{error}</div>}

                  {!isLoading && !error && (
                    <div>
                      <Table striped responsive className="align-middle">
                        <thead>
                          <tr>
                            <th style={{ width: "5%" }}>Rank</th>
                            <th style={{ width: "10%" }}>Avatar</th>
                            <th>Username</th>
                            <th>Trainer Level</th>
                          </tr>
                        </thead>
                        <tbody>
                          {trainers.map((trainer, index) => {
                            const rank = (page - 1) * limit + (index + 1);
                            const level = getLevel(trainer.exp);
                            return (
                              <tr key={trainer.username}>
                                <td>
                                  {rank <= 3 ? (
                                    <img
                                      src={getRankImage(rank)}
                                      alt={`${rank} rank`}
                                    />
                                  ) : (
                                    rank
                                  )}
                                </td>
                                <td>
                                  <img
                                    src={`/avatars/${trainer.avatar}.png`}
                                    alt="avatar"
                                    style={{
                                      width: 40,
                                      height: 40,
                                      borderRadius: "50%",
                                    }}
                                  />
                                </td>
                                <td>
                                  <Link
                                    to={`/playerprofile?user=${trainer.username}`}
                                    style={{
                                      textDecoration: "none",
                                      color: "white",
                                    }}
                                  >
                                    {" "}
                                    {trainer.username}
                                  </Link>
                                </td>
                                <td>{formatNumber(level)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>

                      {/* Pagination Controls */}
                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                          <Button
                            color="primary"
                            disabled={page <= 1}
                            onClick={handlePrev}
                          >
                            Prev
                          </Button>{" "}
                          <Button
                            color="primary"
                            disabled={page >= totalPages}
                            onClick={handleNext}
                          >
                            Next
                          </Button>
                        </div>
                        <div>
                          Page {page} of {totalPages || 1}
                        </div>
                      </div>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TrainerRankings;
